import axios from '@/shared/plugins/Axios'

function Requests () {
  async function updateProfileBasicInfo (payload) {
    try {
      const { data } = await axios.post(`${process.env.VUE_APP_FREELANCER_API_BASE_URL}/profile/basic-information`, payload)
      return data
    } catch (error) {
      return error.response.data
    }
  }

  async function updateWorkExperience (payload) {
    try {
      const { data } = await axios.put(`${process.env.VUE_APP_FREELANCER_API_BASE_URL}/profile/work-experience`, 
      payload,
      {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        },
      })
      return data
    } catch (error) {
      return error.response.data
    }
  }

  async function addSourcedProduct (payload) {
    try {
      const { data } = await axios.post(`${process.env.VUE_APP_FREELANCER_API_BASE_URL}/profile/sourced-product`, payload)
      return data
    } catch (error) {
      return error.response.data
    }
  }

  async function updateIdentityInfo (payload) {
    try {
      const { data } = await axios.post(`${process.env.VUE_APP_FREELANCER_API_BASE_URL}/profile/identity`, payload)
      return data
    } catch (error) {
      return error.response.data
    }
  }

  async function updatePaymentInformation (payload) {
    try {
      const { data } = await axios.put(`${process.env.VUE_APP_FREELANCER_API_BASE_URL}/profile/payment`, 
      payload,
      {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        },
      })
      return data
    } catch (error) {
      return error.response.data
    }
  }

  async function changePassword (payload) {
    try {
      const { data } = await axios.post(`${process.env.VUE_APP_FREELANCER_API_BASE_URL}/change-password`,
      payload,
      {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        },
      })
      return data
    } catch (error) {
      return error.response.data
    }
  }

  return {
    updateProfileBasicInfo,
    updateWorkExperience,
    addSourcedProduct,
    updateIdentityInfo,
    updatePaymentInformation,
    changePassword
  }
}

export default Requests()